import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import no_image from '@doltech/ui/lib/images/No_image_available.png';
import { formatDateString } from '@doltech/utils/lib/date';
import { imgProxyLoader } from '@doltech/utils/lib/image-loader';
import Image from 'next/image';
import * as React from 'react';

import { Layout, MainSection, SetupCard } from './SharedSetupCard';

interface FactSetupCardProps {
  data: any;
}

export const FactSetupCard = (props: FactSetupCardProps) => {
  const { data } = props;
  const { active, content, lastModifiedAt, image } = data;

  return (
    <SetupCard>
      <Layout>
        <MainSection>
          <div className="header-section">
            <div className="image-section">
              <Image
                width="100%"
                height="100%"
                alt={image?.alt || ''}
                src={image?.url || no_image}
                objectFit="cover"
                loader={imgProxyLoader}
              />
            </div>
            {active && (
              <Typography.Paragraph
                className="active-label"
                variant="semi-bold/12"
                color="green100"
                ellipsis={{ rows: 1 }}
              >
                Currently active
              </Typography.Paragraph>
            )}
          </div>
          <div className="info-section">
            <Typography.Title level={3} variant="regular/16" ellipsis={{ rows: 2 }}>
              {content}
            </Typography.Title>

            <Typography.Paragraph variant="regular/14" color="gray100">
              Last modified: {formatDateString(lastModifiedAt)}
            </Typography.Paragraph>
          </div>
        </MainSection>
      </Layout>
    </SetupCard>
  );
};
